import * as ko from "knockout";
import "./../../bindings/c3chart";
function ChecklistFrequencyDistributionDiagramViewModel(tabPage, diagramDataSet, ticks) {
    var self = this;
    self.TabPage = tabPage;
    self.chart = ko.observable();
    self.DiagramDataSet = diagramDataSet;
    self.Refresh = function () { };
}
;
export default ChecklistFrequencyDistributionDiagramViewModel;